/**
 * Runs the specified function when the Enter key is pressed
 *
 * @example <span onKeyDown={onEnterKeyDown(doSomething)}>...</span>
 */
export const onEnterKeyDown = (func: () => void) => {
  return (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      func();
    }
  };
};
